export default {
    buildEncodedUrl({baseEndpointUrl, tenant, code, id}) {
        let url = baseEndpointUrl;

        if (tenant) {
            url += `/${encodeURI(tenant)}`;
            if (code) {
                url += `/${encodeURI(code)}`;
                if (id) {
                    url += `/${encodeURI(id)}`;
                }
            }
        }

        return url;
    },
}
